/**
 * LA RÈGLE DE L'ÉMOJI SEUL — sans aucune dépendance.
 * ============================================================================
 *
 * Séparée de `lib/emoji-seul.mjs` (qui lit des nœuds Vue, donc importe `vue`)
 * pour que le favori « Copier pour… » et `lib/diffusion/formats.mjs` puissent
 * la charger sans embarquer le framework. `lib/emoji-seul.mjs` la ré-exporte :
 * il n'y a qu'une règle, testée (`tests/composables/emoji-seul.test.mjs`).
 */

/**
 * Un émoji : pictogramme (avec teinte, sélecteur U+FE0F, et ses suites liées
 * par U+200D), drapeau (deux indicateurs régionaux), ou touche (`1️⃣`). Un
 * chiffre, une flèche ou une ponctuation n'en sont pas.
 */
export const EMOJI_UN = String.raw`(?:\p{Regional_Indicator}{2}|[#*0-9]️?⃣|\p{Extended_Pictographic}(?:️|\p{Emoji_Modifier})*(?:‍\p{Extended_Pictographic}(?:️|\p{Emoji_Modifier})*)*)`
const SEUL = new RegExp(String.raw`^\s*${EMOJI_UN}(?:\s*${EMOJI_UN}){0,2}\s*$`, 'u')

/** Vrai si `texte` n'est fait que d'un à trois émojis, espaces permis. */
export function emojiSeul(texte) {
  return SEUL.test(String(texte ?? ''))
}

/** Les émojis d'un texte, un par grappe (`🇫🇷` est un seul). */
export function grappesEmoji(texte) {
  return String(texte ?? '').match(new RegExp(EMOJI_UN, 'gu')) ?? []
}
